import {ApiService} from '../services/';

export const getBanner = async (params) => {

    const newParams = {...params, type: params.type || "P"};

    return ApiService({
        url: `banners/`,
        params: newParams
    });
};
